import AppRoutes from './router/Routes';

const App = () => {
  return (
   <AppRoutes />
  );
}

export default App;
